import { ENTITY_LABELS } from "../../utils/labelMapping";

const overviewConfig = [
  {
    name: "Brand Description, Snippets and Themes",
    selector: "div[class*='BrandInsights_brand__']",
    id: "snippet_theme",
    is_active: true,
    is_xpath: false,
  },
  {
    name: "Brand Index Score",
    selector: "div[class*='BrandScore_brand_index_wrapper_']",
    id: "brand_index_score",
    is_active: true,
    is_xpath: false,
  },
  // {
  //   name: "Secondary Category Brand Index Score",
  //   selector: "#secondary_id",
  //   id: "sec_category_brand_index_score",
  //   is_active: true,
  //   is_xpath: false,
  // },
  {
    name: "Rank Details",
    selector: "#reach_id",
    id: "reach_details",
    is_active: true,
  },
  {
    name: "Sentiment Details",
    selector: "#sentiment_id",
    id: "sentiment_details",
    is_active: true,
  },
  {
    name: "Positive Sentiment Examples",
    selector: 'img[alt="5"], img[alt="4"]',
    id: "positive_sentiment_examples",
    is_active: true,
  },
  {
    name: "Negative Sentiment Examples",
    selector: 'img[alt="1"], img[alt="2"]',
    id: "negative_sentiment_examples",
    is_active: true,
  },
  {
    name: `${ENTITY_LABELS.Brand} Pillars`,
    selector: "div[class*='CoreAttributes_card_']",
    id: "brand_pillars",
    is_active: true,
    is_xpath: false,
    generate_summary: true,
  },
  {
    name: "Institution Pillars Details",
    selector: "#print-pdf",
    id: "brand_pillars_details",
    is_active: true,
    is_xpath: false,
  },
  {
    name: ENTITY_LABELS.PurchaseCriteria,
    selector: "div[class*='CategoryDims_card_']",
    id: "purchase_criteria",
    is_active: true,
    is_xpath: false,
    generate_summary: true,
  },
  {
    name: "Applicant Criteria Details",
    selector: "#print-pdf",
    id: "purchase_criteria_details",
    is_active: true,
    is_xpath: false,
  },
  {
    name: "Positive and Negative Attributes",
    selector: ".MuiBox-root:has(> div[class*='MuiGrid-container'])",
    id: "positivenegative_attributes",
    is_active: true,
    is_xpath: false,
    generate_summary: true,
  },
];
const categoryConfig = [
  {
    name: "RBI",
    // selector: "#rbi_id",
    selector: "#rbi_pc",
    id: "category_brand_index_score",
    is_active: true,
    // show_change: true,
  },
  {
    name: `${ENTITY_LABELS.Brand} Pillars`,
    selector: "#bra_id",
    id: "category_brand_pillars",
    is_active: true,
    // show_change: true,
  },
  {
    name: ENTITY_LABELS.PurchaseCriteria,
    selector: "#pur_id",
    id: "category_purchase_criteria",
    is_active: true,
    // show_change: true,
  },
  {
    name: "Institution Pillars Details",
    selector:
      "div:has(> span > span[aria-label*='Eight predefined categories']) > button",
    id: "category_brand_pillars_details",
    is_active: true,
  },
  {
    name: "Applicant Criteria Details",
    selector: "#print-pdf",
    id: "category_purchase_criteria_details",
    is_active: true,
  },
  {
    name: "Positive Attributes",
    selector: "//h6[text()='Positive Attributes']/parent::div",
    id: "category_positive_attributes",
    is_active: true,
    is_xpath: true,
  },
  {
    name: "Negative Attributes",
    selector: "//h6[text()='Negative Attributes']/parent::div",
    id: "category_negative_attributes",
    is_active: true,
    is_xpath: true,
  },
];
const competitionConfig = [
  {
    name: "RBI",
    selector: "#primary_id",
    id: "competition_brand_index_score",
    is_active: true,
    // show_change: true,
  },
  {
    name: `${ENTITY_LABELS.Brand} Pillars`,
    selector: "#brand_pillars_id",
    id: "competition_brand_pillars",
    is_active: true,
    is_xpath: false,
  },
  {
    name: ENTITY_LABELS.PurchaseCriteria,
    selector: "#purchase_criteria_id",
    id: "competition_purchase_criteria",
    is_active: true,
    is_xpath: false,
  },
  {
    name: "Institution Pillars Details",
    selector:
      "div:has(> span > span[aria-label*='Eight predefined categories']) > button",
    id: "competition_brand_pillars_details",
    is_active: true,
  },
  {
    name: "Applicant Criteria Details",
    selector: "#print-pdf",
    id: "competition_purchase_criteria_details",
    is_active: true,
  },
  {
    name: "Positive Attributes",
    selector: "//h6[text()='Positive Attributes']/parent::div",
    id: "competition_positive_attributes",
    is_active: true,
    is_xpath: true,
  },
  {
    name: "Negative Attributes",
    selector: "//h6[text()='Negative Attributes']/parent::div",
    id: "competition_negative_attributes",
    is_active: true,
    is_xpath: true,
  },
];

const llmConfig = [
  {
    name: "RBI",
    // selector: "#rbi_id",
    selector: "#rbi_pc",
    id: "llm_brand_index_score",
    is_active: true,
    // show_change: true,
  },
  // {
  //   name: "Reach",
  //   selector: "#rank_id",
  //   id: "llm_reach",
  //   is_active: true,
  //   show_change: true,
  // },
  // {
  //   name: "Sentiment",
  //   selector: "#fav_id",
  //   id: "llm_sentiment",
  //   is_active: true,
  //   show_change: true,
  // },
  {
    name: `${ENTITY_LABELS.Brand} Pillars`,
    selector: "#bra_id",
    id: "llm_brand_pillars",
    is_active: true,
    // show_change: true,
  },
  {
    name: ENTITY_LABELS.PurchaseCriteria,
    selector: "#pur_id",
    id: "llm_purchase_criteria",
    is_active: true,
    // show_change: true,
  },
  {
    name: "Institution Pillars Details",
    selector:
      "div:has(> span > span[aria-label*='Eight predefined categories']) > button",
    id: "llm_brand_pillars_details",
    is_active: true,
  },
  {
    name: "Applicant Criteria Details",
    selector: "#print-pdf",
    id: "llm_purchase_criteria_details",
    is_active: true,
  },
  {
    name: "Positive Attributes",
    selector: "//h6[text()='Positive Attributes']/parent::div",
    id: "llm_positive_attributes",
    is_active: true,
    is_xpath: true,
  },
  {
    name: "Negative Attributes",
    selector: "//h6[text()='Negative Attributes']/parent::div",
    id: "llm_negative_attributes",
    is_active: true,
    is_xpath: true,
  },
];

const marketConfig = [
  {
    name: "RBI",
    // selector: "#rbi_id",
    selector: "#rbi_pc",
    id: "market_brand_index_score",
    is_active: true,
    // show_change: true,
  },
  // {
  //   name: "Reach",
  //   selector: "#rank_id",
  //   id: "market_reach",
  //   is_active: true,
  //   show_change: true,
  // },
  // {
  //   name: "Sentiment",
  //   selector: "#fav_id",
  //   id: "market_sentiment",
  //   is_active: true,
  //   show_change: true,
  // },
  {
    name: `${ENTITY_LABELS.Brand} Pillars`,
    selector: "#bra_id",
    id: "market_brand_pillars",
    is_active: true,
    // show_change: true,
  },
  {
    name: ENTITY_LABELS.PurchaseCriteria,
    selector: "#pur_id",
    id: "market_purchase_criteria",
    is_active: true,
    // show_change: true,
  },
  {
    name: "Institution Pillars Details",
    selector:
      "div:has(> span > span[aria-label*='Eight predefined categories']) > button",
    id: "market_brand_pillars_details",
    is_active: true,
  },
  {
    name: "Applicant Criteria Details",
    selector: "#print-pdf",
    id: "market_purchase_criteria_details",
    is_active: true,
  },
  {
    name: "Positive Attributes",
    selector: "//h6[text()='Positive Attributes']/parent::div",
    id: "market_positive_attributes",
    is_active: true,
    is_xpath: true,
  },
  {
    name: "Negative Attributes",
    selector: "//h6[text()='Negative Attributes']/parent::div",
    id: "market_negative_attributes",
    is_active: true,
    is_xpath: true,
  },
];

const personaConfig = [
  {
    name: "RBI",
    // selector: "#rbi_id",
    selector: "#rbi_pc",
    id: "persona_brand_index_score",
    is_active: true,
    // show_change: true,
  },
  // {
  //   name: "Reach",
  //   selector: "#rank_id",
  //   id: "persona_reach",
  //   is_active: true,
  //   show_change: true,
  // },
  // {
  //   name: "Sentiment",
  //   selector: "#fav_id",
  //   id: "persona_sentiment",
  //   is_active: true,
  //   show_change: true,
  // },
  {
    name: `${ENTITY_LABELS.Brand} Pillars`,
    selector: "#bra_id",
    id: "persona_brand_pillars",
    is_active: true,
    // show_change: true,
  },
  {
    name: ENTITY_LABELS.PurchaseCriteria,
    selector: "#pur_id",
    id: "persona_purchase_criteria",
    is_active: true,
    // show_change: true,
  },
  {
    name: "Institution Pillars Details",
    selector:
      "div:has(> span > span[aria-label*='Eight predefined categories']) > button",
    id: "persona_brand_pillars_details",
    is_active: true,
  },
  {
    name: "Applicant Criteria Details",
    selector: "#print-pdf",
    id: "persona_purchase_criteria_details",
    is_active: true,
  },
  {
    name: "Positive Attributes",
    selector: "//h6[text()='Positive Attributes']/parent::div",
    id: "persona_positive_attributes",
    is_active: true,
    is_xpath: true,
  },
  {
    name: "Negative Attributes",
    selector: "//h6[text()='Negative Attributes']/parent::div",
    id: "persona_negative_attributes",
    is_active: true,
    is_xpath: true,
  },
];

const sourceConfig = [
  {
    name: "Brand Query Sources",
    selector: "#brand_id",
    id: "source_brand_source",
    is_active: true,
    is_xpath: false,
  },
  {
    name: "Category Query Sources",
    selector: "#category_id",
    id: "source_category_source",
    is_active: true,
    is_xpath: false,
  },
];

const actionConfig = [
  {
    "id": "actions_table",             // 👈 id for the table container
    "name": "Actions Table",
    "selector": "#FocusArea",      // Puppeteer will screenshot this element
    "is_active": true,
    "is_xpath": false
  }
]

const initialBrandTabs = [
  { id: "overview", label: "Overview", config: overviewConfig },
  { id: "category", label: "Category", config: categoryConfig },
  { id: "competition", label: "Competition", config: competitionConfig },
  { id: "llm", label: "LLM", config: llmConfig },
  { id: "market", label: "Market", config: marketConfig },
  { id: "persona", label: "Personas", config: personaConfig },
  { id: "source", label: "Sources", config: sourceConfig },
  { id: "actions", label: "Actions", config: actionConfig },
];

export { initialBrandTabs };
